import { SVGProps } from "react";

const YandexIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.0145 14.7858L23.4468 12.7588C23.4468 16.3074 21.0043 19.9739 18.8375 23.4666L15.123 29L16.7482 18.8969L19.0145 14.7858Z"
				fill="#E00000"
			/>
			<path
				d="M15.9727 20.0529C20.1148 20.0529 23.4727 16.6832 23.4727 12.5265C23.4727 8.36971 20.1148 5 15.9727 5C11.8305 5 8.47266 8.36971 8.47266 12.5265C8.47266 16.6832 11.8305 20.0529 15.9727 20.0529Z"
				fill="#FF3333"
			/>
			<path
				d="M15.9727 15.5255C17.623 15.5255 18.9609 14.1829 18.9609 12.5267C18.9609 10.8704 17.623 9.52783 15.9727 9.52783C14.3223 9.52783 12.9844 10.8704 12.9844 12.5267C12.9844 14.1829 14.3223 15.5255 15.9727 15.5255Z"
				fill="white"
			/>
		</svg>
	);
};

export default YandexIcon;
